export const OBLIGATION_STATUS = {
    UnderApproval: "UNDER_APPROVAL",
    UnderFiling: "UNDER_FILING",
    Filed: "FILED",
    UnderReview: "UNDER_REVIEW",
    UnderPreparation: "UNDER_PREPARATION",
    NotStarted: "NOT_STARTED",
};

export const ASM_COMPLETE_STATUS = "COMPLETE";
export const ACKNOWLEDGEMENT_STRUCTURE_MAP_KEY = {
    Trends: "TRENDS",
    Audit: "AUDIT",
    Checklist: "CHECKLIST",
    Exceptions: "EXCEPTIONS",
    Summary: "SUMMARY",
    TransactionReview: "TRANSACTION_REVIEW",
    Insight: "INSIGHT",
};

export const PHASTOS_OBLIGATION = {
    MOG: "MOG",
    VAT: "VAT",
    DS: "DS",
    DST:"DST"
};